import React, { Component } from 'react';
import { WatchlistListsModel, WatchlistModel } from '../../../domain/watchlist/WatchlistDomains';
import WatchlistDataNotFoundComponent from '../detail/WatchlistDataNotFoundComponent';
import WatchlistRemarksComponent from '../detail/WatchlistRemarksComponent';
import WatchlistSourcesComponent from '../detail/WatchlistSourcesComponent';
import WatchlistResultComponent from '../detail/WatchlistResultComponent';
import { WatchlistType } from '../../../constant/Constants';
import WatchlistImageComponent from '../detail/WatchlistImageComponent';
import { CustomListSourceDisplay } from '../../../util/WatchlistCustomListSourceLoader';

class WatchlistInformationComponent extends Component<Props, State> {
  public state = new State();

  public render() {
    const { selectedResponse, watchlistResponse, type, preferredCustomListSource } = this.props;
    if (selectedResponse == undefined) return <WatchlistDataNotFoundComponent />;
    return (
      <div className={'max-h-[calc(100vh-16rem)] w-full pb-5 pt-2.5 px-5 overflow-y-scroll'}>
        <WatchlistResultComponent selectedResponse={selectedResponse} watchlistResponse={watchlistResponse} type={type} preferredCustomListSource={preferredCustomListSource}/>
        <WatchlistRemarksComponent selectedResponse={selectedResponse} watchlistResponse={watchlistResponse} preferredCustomListSource={preferredCustomListSource}/>
        <WatchlistSourcesComponent selectedResponse={selectedResponse} watchlistResponse={watchlistResponse} preferredCustomListSource={preferredCustomListSource}/>
        {type == 'Individual' && <WatchlistImageComponent selectedResponse={selectedResponse} />}
      </div>
    );
  }
}

interface Props {
  selectedResponse: WatchlistModel[];
  watchlistResponse: WatchlistListsModel[];
  type: WatchlistType | undefined;
  preferredCustomListSource?: CustomListSourceDisplay;
}

class State {}

export default WatchlistInformationComponent;
